import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerMailPecModalComponent } from './worker-mail-pec-modal';

export const WorkerMailPecModalModule: string = ng
    .module('worker-mail-pec-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerMailPecModalComponent', WorkerMailPecModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-mail-pec-modal/worker-mail-pec-modal.module.ts